import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=73f0c71c"
import script from "./Lessons.vue?vue&type=script&lang=js"
export * from "./Lessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports